<template>
  <section id="audience" class="section-block">
    <div class="section-container">
      <span v-reveal class="section-label">Audience</span>
      <h2 v-reveal class="section-title">适用客户</h2>
      <p v-reveal class="section-subtitle reveal--delay-1">
        覆盖不同规模与类型的跨境企业，提供灵活可扩展的数字化方案
      </p>
      <a-row :gutter="[16, 16]">
        <a-col v-for="(label, index) in items" :key="label" :xs="24" :sm="12" :lg="6">
          <div v-reveal :class="'reveal--delay-' + (index % 4 + 1)">
            <div class="audience-pill">{{ label }}</div>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script>
import { audienceItems } from "../defaultHomeContent";

export default {
  data() {
    return {
      items: audienceItems
    };
  }
};
</script>

<style scoped>
.audience-pill {
  border-radius: var(--radius);
  padding: 20px 16px;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--primary-dark);
  border: 1px solid var(--border);
  background: var(--bg);
  transition: transform 0.3s, border-color 0.25s, box-shadow 0.3s;
}

.audience-pill:hover {
  transform: translateY(-4px);
  border-color: rgba(22, 119, 255, 0.25);
  box-shadow: 0 12px 26px rgba(22, 119, 255, 0.1);
}

@media (prefers-reduced-motion: reduce) {
  .audience-pill:hover {
    transform: none;
  }
}
</style>
